import * as types from '../action-types';
import { FeedbackReducerType } from '../decisionState.types';
import { FeedbackActions } from '../actions';

const initialState: FeedbackReducerType = {
  isOpen: false,
  top: -9999,
  left: 0,
};

export function feedbackReducer(
  state: FeedbackReducerType = initialState,
  action: FeedbackActions,
) {
  switch (action.type) {
    case types.openFeedbackPopover: {
      const { data } = action.payload;
      return { ...state, ...data };
    }
    case types.closeFeedbackPopover: {
      return {
        ...state,
        isOpen: false,
        top: -9999,
      };
    }
    default: {
      return state;
    }
  }
}
